import PhotoOverlayItem from '../src/PhotoOverlayItem';
export default PhotoOverlayItem;
